module.exports = __webpack_public_path__ + "img/usa.fb2bbe1a.webp";